<template>
  <div>
    <label v-if="label" class="form-label" :class="{'text-gray-500': $attrs.disabled}" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="$attrs" class="form-input h-10"
           :class="{error: errors.length, 'text-gray-500': $attrs.disabled}" :type="type" min="1" :value="value"
           @input="$emit('input', type === 'number' ? parseInt($event.target.value) : $event.target.value)">
    <div v-if="errors.length && (typeof errors[0] === 'string')" class="form-error whitespace-nowrap">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
    label: String,
    errors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    }
  }
}
</script>
